export default "__VITE_ASSET__BkLM20b2__"